// Tooltip.tsx
import React, {ReactNode, RefObject, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

type TooltipProps = {
    targetRef?: RefObject<HTMLElement>;
    children: ReactNode;
};

export function Tooltip({ targetRef, children }: TooltipProps) {
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if(!targetRef || !targetRef.current) return;
        const el = targetRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        setCoords({
            top: rect.top + rect.height / 2,
            left: rect.right + 8, // 8px de marge
        });
    }, [targetRef]);

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'fixed',
                top: coords.top,
                left: coords.left,
                transform: 'translateY(-50%)',
            }}
            className="rounded-md px-2 py-1 bg-main-color text-white text-sm font-normal whitespace-nowrap shadow-lg z-9999"
        >
            {children}
        </div>,
        document.body
    );
}
